var _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 8,
    fill: "rgb(205,45,55)",
    rx: 7,
    ry: 7
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 0,
    style: {
      whiteSpace: "pre"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 13,
    fill: "rgb(0,0,0)",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: 700,
    style: {
      whiteSpace: "pre",
      textTransform: "none"
    }
  }, "!"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamacao);
export default __webpack_public_path__ + "static/media/exclamacao.97a507cbb5b7328432afa35c1098e365.svg";
export { ForwardRef as ReactComponent };